import type { Item } from '@/components/SelectFieldComp';
import type { AbsenceReasonDetailInfectionType } from '@/types/domain/attendance/valueObjects/absenceReasonDetailInfection';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { ABSENCE_REASON_DETAIL_INFECTION_TYPE } from '@/types/domain/attendance/valueObjects/absenceReasonDetailInfection';

export class AbsenceReasonDetailInfection extends PrimitiveValueObject<
  AbsenceReasonDetailInfectionType
> {
  /**
   * 作成
   * @param props 値
   * @returns 値
   */
  static create(props: AbsenceReasonDetailInfectionType): AbsenceReasonDetailInfection {
    return new AbsenceReasonDetailInfection(props);
  }

  /** キー */
  static get key(): string {
    return 'reasonDetailInfection';
  }

  /** ラベル */
  static get label(): string {
    return '詳細';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** アイテムリスト */
  static get items(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items: Item[] = [];
    for (let i = 0; i < ABSENCE_REASON_DETAIL_INFECTION_TYPE.length; i += 1) {
      items.push({
        id: ABSENCE_REASON_DETAIL_INFECTION_TYPE[i],
        name: ABSENCE_REASON_DETAIL_INFECTION_TYPE[i],
      });
    }
    return items;
  }
}
